define("shared/components/shared/credentials/page-item", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@ember/string", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _string, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/string",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li
    class="o--card tAC--statusCard {{if @isActivePage 'tAC--statusCard--active' ''}}"
    {{on "click" (fn (optional @selectPage) @page)}}
  >
    <div class="o--cardBody u--p__lr__sm">
      {{! User Profile }}
      <div class="o--user">
        <img class="o--user__avatar" src={{@page.picture.data.url}} />
        <span class="o--user__avatarChild--facebook"><i class="i--facebook--w"></i></span>
        <span class="o--user__title">
          {{if @page.name_with_location_descriptor @page.name_with_location_descriptor @page.name}}
        </span>
        <span class="o--user__desc">{{t "credentials.connection.facebook_page"}}</span>
        {{! Icon }}
        {{#if @isActivePage}}
          {{#unless @missingScopes}}
            {{#if this.insufficientPermissions}}
              {{svg-jar "delete-circle" class="o--icon--md o--icon--danger tAC--statusCard--icon"}}
            {{else if this.isConnectedToOtherProfile}}
              {{svg-jar "delete-circle" class="o--icon--md o--icon--danger tAC--statusCard--icon"}}
            {{else}}
              {{svg-jar "verified-solid" class="o--icon--md o--icon--success tAC--statusCard--icon"}}
            {{/if}}
          {{/unless}}
        {{else}}
          {{svg-jar "circle" class="o--icon--md u--text--light tAC--statusCard--icon"}}
        {{/if}}
      </div>
      {{#unless @missingScopes}}
        <div class="tAC--statusCard__info">
          {{#if this.insufficientPermissions}}
            <hr class="u--m__tb__sm" />
            <p>{{html-safe (t "credentials.pageItem.cant_connect")}}</p>
            <p class="u--m__b__0">{{html-safe (t "credentials.pageItem.not_admin")}}</p>
            <ul class="u--p__l__md u--p__t__xs">
              <li>{{t "credentials.pageItem.not_admin_step_1"}}</li>
              <li>{{t "credentials.pageItem.not_admin_step_2"}}</li>
            </ul>
          {{else if this.isConnectedToOtherProfile}}
            <hr class="u--m__tb__sm" />
            <p>{{html-safe (t "credentials.pageItem.cant_connect")}}</p>
            <p class="u--m__b__0">
              {{html-safe (t "credentials.pageItem.already_connected" username=this.instagramAccount.username)}}
            </p>
          {{else}}
            <hr class="u--m__tb__sm" />
            <p class="u--m__b__0">{{html-safe (t "credentials.pageItem.admin" role=this.role)}}</p>
          {{/if}}
        </div>
      {{/unless}}
    </div>
  </li>
  */
  {
    "id": "N/f3y1jU",
    "block": "[[[11,\"li\"],[16,0,[29,[\"o--card tAC--statusCard \",[52,[30,1],\"tAC--statusCard--active\",\"\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[28,[37,3],[[30,2]],null],[30,3]],null]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--cardBody u--p__lr__sm\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n      \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[15,\"src\",[30,3,[\"picture\",\"data\",\"url\"]]],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__avatarChild--facebook\"],[12],[10,\"i\"],[14,0,\"i--facebook--w\"],[12],[13],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__title\"],[12],[1,\"\\n        \"],[1,[52,[30,3,[\"name_with_location_descriptor\"]],[30,3,[\"name_with_location_descriptor\"]],[30,3,[\"name\"]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,[28,[35,4],[\"credentials.connection.facebook_page\"],null]],[13],[1,\"\\n\"],[41,[30,1],[[[41,[51,[30,4]],[[[41,[30,0,[\"insufficientPermissions\"]],[[[1,\"            \"],[1,[28,[35,6],[\"delete-circle\"],[[\"class\"],[\"o--icon--md o--icon--danger tAC--statusCard--icon\"]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isConnectedToOtherProfile\"]],[[[1,\"            \"],[1,[28,[35,6],[\"delete-circle\"],[[\"class\"],[\"o--icon--md o--icon--danger tAC--statusCard--icon\"]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,6],[\"verified-solid\"],[[\"class\"],[\"o--icon--md o--icon--success tAC--statusCard--icon\"]]]],[1,\"\\n          \"]],[]]]],[]]]],[]],null]],[]],[[[1,\"        \"],[1,[28,[35,6],[\"circle\"],[[\"class\"],[\"o--icon--md u--text--light tAC--statusCard--icon\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[41,[51,[30,4]],[[[1,\"      \"],[10,0],[14,0,\"tAC--statusCard__info\"],[12],[1,\"\\n\"],[41,[30,0,[\"insufficientPermissions\"]],[[[1,\"          \"],[10,\"hr\"],[14,0,\"u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,7],[[28,[37,4],[\"credentials.pageItem.cant_connect\"],null]],null]],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,7],[[28,[37,4],[\"credentials.pageItem.not_admin\"],null]],null]],[13],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"u--p__l__md u--p__t__xs\"],[12],[1,\"\\n            \"],[10,\"li\"],[12],[1,[28,[35,4],[\"credentials.pageItem.not_admin_step_1\"],null]],[13],[1,\"\\n            \"],[10,\"li\"],[12],[1,[28,[35,4],[\"credentials.pageItem.not_admin_step_2\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isConnectedToOtherProfile\"]],[[[1,\"          \"],[10,\"hr\"],[14,0,\"u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,7],[[28,[37,4],[\"credentials.pageItem.cant_connect\"],null]],null]],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[[28,[37,4],[\"credentials.pageItem.already_connected\"],[[\"username\"],[[30,0,[\"instagramAccount\",\"username\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"hr\"],[14,0,\"u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,7],[[28,[37,4],[\"credentials.pageItem.admin\"],[[\"role\"],[[30,0,[\"role\"]]]]]],null]],[13],[1,\"\\n        \"]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@isActivePage\",\"@selectPage\",\"@page\",\"@missingScopes\"],false,[\"if\",\"on\",\"fn\",\"optional\",\"t\",\"unless\",\"svg-jar\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/credentials/page-item.hbs",
    "isStrictMode": false
  });

  let PageItemComponent = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class PageItemComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor, this);
    }

    get page() {
      return this.args.page ?? null;
    }

    get instagramAccount() {
      return this.page.instagram_business_account;
    }

    get tasks() {
      return this.page.tasks;
    }

    get isConnectedToOtherProfile() {
      return this.instagramAccount?.id && this.instagramAccount.id != this.args.socialProfile.businessAccountId;
    }

    get insufficientPermissions() {
      return !this.instagramBusiness.sufficientPermissions(this.page);
    }

    get canCreateContent() {
      return this.tasks && this.tasks.includes('CREATE_CONTENT');
    }

    get canManage() {
      return this.tasks && this.tasks.includes('MANAGE');
    }

    get role() {
      if (this.canManage) {
        return 'Admin';
      } else if (this.canCreateContent) {
        return 'Editor';
      }

      return 'Moderator';
    }

    openPageSettings() {
      window.open(`https://www.facebook.com/${(0, _string.dasherize)(this.page.name)}-${this.page.id}/settings/?tab=instagram_management`);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openPageSettings", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openPageSettings"), _class.prototype)), _class));
  _exports.default = PageItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PageItemComponent);
});